(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["kik-community"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('click', (event) => {
    const opener = event.target.closest('[data-kik-look-open]');

    if (opener) {
      const dialog = document.getElementById(opener.dataset.kikLookOpen);
      if (dialog && typeof dialog.showModal === 'function') {
        dialog.showModal();
      }
      return;
    }

    if (event.target.closest('[data-kik-look-close]')) {
      event.target.closest('dialog').close();
      return;
    }

    if (event.target.matches('dialog.kik-look')) {
      event.target.close();
    }
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["kik-laufband"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('click', (event) => {
    const button = event.target.closest('[data-kik-laufband-toggle]');

    if (!button) {
      return;
    }

    const band = button.closest('.kik-laufband');
    const paused = band.classList.toggle('is-paused');

    button.setAttribute('aria-pressed', paused ? 'true' : 'false');
    button.querySelector('.sr-only').textContent = paused ? button.dataset.tFortsetzen : button.dataset.tAnhalten;
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["kik-reiter"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const select = (tab) => {
      const list = tab.closest('[role="tablist"]');
      const tabs = Array.from(list.querySelectorAll('[role="tab"]'));

      tabs.forEach((other) => {
        const selected = other === tab;
        other.setAttribute('aria-selected', selected ? 'true' : 'false');
        if (selected) {
          other.removeAttribute('tabindex');
        } else {
          other.setAttribute('tabindex', '-1');
        }
        const panel = document.getElementById(other.getAttribute('aria-controls'));
        if (panel) {
          panel.hidden = !selected;
        }
      });
    };

    document.addEventListener('click', (event) => {
      const tab = event.target.closest('[data-kik-reiter] [role="tab"]');
      if (tab) {
        select(tab);
      }
    });

    document.addEventListener('keydown', (event) => {
      const tab = event.target.closest('[data-kik-reiter] [role="tab"]');
      if (!tab || !['ArrowLeft', 'ArrowRight', 'Home', 'End'].includes(event.key)) {
        return;
      }

      const tabs = Array.from(tab.closest('[role="tablist"]').querySelectorAll('[role="tab"]'));
      const index = tabs.indexOf(tab);
      let next = index;

      if (event.key === 'ArrowRight') next = (index + 1) % tabs.length;
      if (event.key === 'ArrowLeft') next = (index - 1 + tabs.length) % tabs.length;
      if (event.key === 'Home') next = 0;
      if (event.key === 'End') next = tabs.length - 1;

      event.preventDefault();
      select(tabs[next]);
      tabs[next].focus();
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["kik-topbar"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('click', (event) => {
    const button = event.target.closest('[data-kik-ts-close]');

    if (!button) {
      return;
    }

    const bar = button.closest('[data-kik-ts-bar]');
    bar.hidden = true;

    try {
      sessionStorage.setItem('kik-ts-bar-closed', '1');
    } catch (error) {}

    const logo = document.querySelector('a.header__logo');
    if (logo) {
      logo.focus();
    }
  });

  } catch(e) { console.error(e); }
})();
})();
